var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isReady
    ? _c(
        "div",
        {
          key: _vm.refreshKey,
          class: [
            "agreement-form-embed",
            "brand-agreement-surface",
            {
              "completed-form-embed": _vm.completed,
              "mx-brand-form-surface": _vm.branding
            }
          ].concat(_vm.brandClasses),
          style: _vm.formStyle + ";" + _vm.brandStyle,
          attrs: { id: _vm.item.id },
          on: {
            click: function($event) {
              return _vm.$emit("click", $event)
            }
          }
        },
        [
          _vm.item.discoveryTemplate && _vm.schema.length
            ? _c(
                "div",
                { staticClass: "mx-brand-form" },
                [
                  _vm._l(_vm.renderedItems, function(entry) {
                    return _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isItemVisible(entry.item),
                            expression: "isItemVisible(entry.item)"
                          }
                        ],
                        key: entry.item.id,
                        attrs: { id: entry.item.id }
                      },
                      [
                        _c("item-renderer", {
                          ref: "item",
                          refInFor: true,
                          attrs: {
                            index: entry.index,
                            item: entry.item,
                            styles: _vm.styles,
                            font: _vm.font,
                            "button-props": _vm.buttonProps,
                            disabled:
                              !_vm.clientMode || _vm.agreement.fullyExecuted,
                            "current-page": entry.page + 1,
                            "page-count": _vm.pages.length,
                            "account-logo": _vm.accountLogo,
                            active: false,
                            results: _vm.results,
                            "known-data": _vm.knownData
                          },
                          on: {
                            "next-page": function($event) {
                              return _vm.nextPage()
                            },
                            "previous-page": function($event) {
                              return _vm.previousPage()
                            },
                            input: function($event) {
                              return _vm.handleInput($event)
                            }
                          }
                        })
                      ],
                      1
                    )
                  }),
                  _vm.isLastPage && !_vm.printing
                    ? _c("div", [
                        _c(
                          "div",
                          {
                            staticClass: "row-format gap-2 pt-2 px-2",
                            style:
                              "width: 100%; justify-content: " +
                              _vm.justification
                          },
                          [
                            _vm.pages.length > 1
                              ? _c(
                                  "v-btn",
                                  {
                                    staticClass: "elevation-0",
                                    style:
                                      "font-size: var(--form-font-size) !important; " +
                                      (_vm.buttonProps.block
                                        ? "width: 49%!important;"
                                        : ""),
                                    attrs: {
                                      color: _vm.styles.buttonColor,
                                      "x-small": _vm.buttonProps.xSmall,
                                      small: _vm.buttonProps.small,
                                      large: _vm.buttonProps.large,
                                      "x-large": _vm.buttonProps.xLarge
                                    },
                                    on: { click: _vm.previousPage }
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        staticClass: "mr-1",
                                        attrs: {
                                          color: _vm.styles.buttonTextColor
                                        }
                                      },
                                      [_vm._v(_vm._s(_vm.styles.prevPageIcon))]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        style:
                                          "font-family: " +
                                          _vm.font +
                                          "; ; text-transform: none; color: " +
                                          _vm.styles.buttonTextColor
                                      },
                                      [_vm._v(_vm._s(_vm.styles.prevPageText))]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ])
                    : _vm._e()
                ],
                2
              )
            : _vm.form && _vm.schema.length === 0
            ? _c(
                "div",
                {
                  staticClass: "row-format centered",
                  staticStyle: {
                    height: "100%",
                    border: "1px solid var(--v-gray_20-base)",
                    "min-height": "100px"
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "font-gray_60 row-format align-center" },
                    [
                      _c(
                        "v-icon",
                        {
                          staticClass: "material-symbols-outlined",
                          attrs: { color: "gray_60" }
                        },
                        [_vm._v("warning")]
                      ),
                      _c("div", [_vm._v("Selected form has no content")])
                    ],
                    1
                  )
                ]
              )
            : _c(
                "div",
                {
                  staticClass: "row-format centered",
                  staticStyle: {
                    height: "100%",
                    border: "1px solid var(--v-gray_20-base)",
                    "min-height": "100px"
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "font-gray_60 row-format align-center" },
                    [
                      _c(
                        "v-icon",
                        {
                          staticClass: "material-symbols-outlined",
                          attrs: { color: "gray_60" }
                        },
                        [_vm._v("description")]
                      ),
                      _c("div", [
                        _vm._v("Please select an embedded form template")
                      ])
                    ],
                    1
                  )
                ]
              )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }